import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import LclBoardPage from './LclBoardPage';
import { SUBESTADOS_FINALIZADAS } from '../utils/lclBoardConstants';

/**
 * Tablero "Finalizadas" — solicitudes LCL en estado `Aprobada`.
 *
 * Sub-estados:
 *  - "Cerrada"   : la operación terminó
 *  - "Archivada" : ya no se consulta habitualmente
 */
export default function LclCompletedBoardPage() {
  return (
    <LclBoardPage
      estado="Aprobada"
      titulo="Operaciones LCL finalizadas"
      subtitulo="Operaciones cerradas · consulta histórica y archivo"
      icon={CheckCircle2}
      iconClass="bg-emerald-100 text-emerald-700"
      subEstadoOptions={SUBESTADOS_FINALIZADAS}
      subEstadoDefault="Cerrada"
      exportFileName="lcl_finalizadas"
    />
  );
}
